/* MYNTELO device fit v1.0 (v5.5, 2026-10-15, Michael). Danny: "detect user device and adapt to it by aligning products to their device."
   Runs in the browser only; nothing leaves the device except the analytics events below (brand / model / confidence, no identifiers).
   1. Detect
      - Samsung Galaxy: exact model from the model code (UA Client Hints getHighEntropyValues(['model']) in Chrome / Samsung Internet,
        else the "SM-xxxx" in the user agent of in-app browsers). Mapped to our catalog names (GX below). Unsold Galaxy models = no action.
      - iPhone: Apple hides the model, so the screen (CSS px, portrait, @3x) gives a size class; candidates newest first (IP below).
        Shown as a guess with one-tap chips, never as certain (a wrong model = a reprint).
      - Anything the visitor picks in a Model dropdown is remembered (localStorage 'myntelo:device') and wins over detection for that brand.
   2. Align
      - Model dropdowns (product pages + the home product card): open on the visitor's phone; "Fits your Galaxy S25 Ultra" / "Your iPhone?" chips.
        A link that already names a variant (?variant=, ads / Shopping) is never overridden; a suggestion chip is shown instead.
      - iPhone design on a Galaxy (and the reverse): a nudge above the Device switch to this design's twin; the visitor's own device is dotted.
      - Galaxy visitors on the homepage: "Shop cases" goes to Galaxy cases, the featured grid shows each design's Galaxy version.
   3. Measure: dataLayer + Shopify.analytics events myntelo_device (detected), myntelo_device_pick (chip/dropdown), myntelo_device_nudge (nudge click).
   QA override: ?mdf=iphone:402x874 | ?mdf=galaxy:SM-S938U | ?mdf=off (kept for the session).
   Config from sections/myntelo-header.liquid: window.MynteloDeviceCfg = {gx: galaxy collection url, ip: iPhone collection url}. */
(function(){
  'use strict';
  var W=window, D=document, KEY='myntelo:device', SKEY='myntelo:device-qa';
  var CFG=W.MynteloDeviceCfg||{};
  /* Samsung model code (SM-xxxx, region letter ignored) -> catalog option name. Sources: FCC/retail listings (S26 S942/S947/S948, S26 FE S741, Z Flip 8 F776). */
  var GX={S942:'Samsung Galaxy S26',S947:'Samsung Galaxy S26 Plus',S948:'Samsung Galaxy S26 Ultra',S741:'Samsung Galaxy S26 FE',
    S931:'Samsung Galaxy S25',S936:'Samsung Galaxy S25 Plus',S938:'Samsung Galaxy S25 Ultra',
    S921:'Samsung Galaxy S24',S926:'Samsung Galaxy S24 Plus',S928:'Samsung Galaxy S24 Ultra',
    S916:'Samsung Galaxy S23 Plus 5G',S918:'Samsung Galaxy S23 Ultra 5G',
    S901:'Samsung Galaxy S22 5G',S906:'Samsung Galaxy S22 Plus 5G',S908:'Samsung Galaxy S22 Ultra 5G',
    F776:'Samsung Galaxy Z Flip 8'};
  /* iPhone screen classes (CSS px portrait, @3x) -> models, newest first. iPhone 18 Pro / Pro Max assumed to keep the 17 Pro / Pro Max sizes. */
  var IP={'402x874':['iPhone 18 Pro','iPhone 17 Pro','iPhone 17','iPhone 16 Pro'],
    '440x956':['iPhone 18 Pro Max','iPhone 17 Pro Max','iPhone 16 Pro Max'],
    '420x912':['iPhone 17 Air'],
    '393x852':['iPhone 16','iPhone 15 Pro','iPhone 15','iPhone 14 Pro'],
    '430x932':['iPhone 16 Plus','iPhone 15 Pro Max','iPhone 15 Plus','iPhone 14 Pro Max'],
    '390x844':['iPhone 17e','iPhone 16e','iPhone 14','iPhone 13','iPhone 13 Pro','iPhone 12','iPhone 12 Pro'],
    '428x926':['iPhone 14 Plus','iPhone 13 Pro Max','iPhone 12 Pro Max'],
    '375x812':['iPhone 13 Mini','iPhone 12 Mini']};

  function get(k, s){ try{ var v=(s?sessionStorage:localStorage).getItem(k); return v ? JSON.parse(v) : null; }catch(e){ return null; } }
  function put(k, v, s){ try{ (s?sessionStorage:localStorage).setItem(k, JSON.stringify(v)); }catch(e){} }
  function kindOf(m){ return /^iPhone/i.test(m||'') ? 'iphone' : /^Samsung Galaxy/i.test(m||'') ? 'galaxy' : null; }
  function short(m){ return String(m||'').replace(/^Samsung /,'').replace(/ 5G$/,''); }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function emit(name, d){
    try{ var o={event:name}; for(var k in d) o[k]=d[k]; (W.dataLayer=W.dataLayer||[]).push(o); }catch(e){}
    try{ if(W.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, d); }catch(e){}
  }

  /* ---------- 1. detect ---------- */
  function fromCode(out, s){
    var c=String(s||'').toUpperCase().match(/SM-([A-Z]\d{3})/);
    if(!c) return out;
    out.brand='galaxy'; out.code='SM-'+c[1];
    if(GX[c[1]]){ out.model=GX[c[1]]; out.cands=[out.model]; out.conf='exact'; }
    return out;
  }
  function fromScreen(out, w, h, dpr){
    var a=Math.min(w,h), b=Math.max(w,h), k=a+'x'+b;
    out.brand='iphone'; out.cls=k; out.how=out.how||'screen';
    if(IP[k] && Math.round(dpr)===3){ out.cands=IP[k].slice(); out.model=IP[k][0]; out.conf=IP[k].length===1 ? 'high' : 'guess'; }
    return out;
  }
  function detect(){
    return new Promise(function(res){
      var out={os:'other', brand:null, model:null, cands:[], conf:'none', how:''}, ua=navigator.userAgent||'';
      var qa=(location.search.match(/[?&]mdf=([^&]+)/)||[])[1];
      if(qa){ qa=decodeURIComponent(qa); put(SKEY, qa, true); } else qa=get(SKEY, true);
      if(qa==='off') return res(out);
      if(qa){
        out.how='qa';
        var p=qa.split(':');
        if(p[0]==='galaxy'){ out.os='android'; return res(fromCode(out, p[1])); }
        if(p[0]==='iphone'){ out.os='ios'; var wh=(p[1]||'').split('x'); return res(fromScreen(out, +wh[0], +wh[1], 3)); }
      }
      if(/iPhone/.test(ua)){ out.os='ios'; var s=W.screen||{}; return res(fromScreen(out, s.width||0, s.height||0, W.devicePixelRatio||0)); }
      if(!/Android/.test(ua)) return res(out);
      out.os='android';
      var done=false, fin=function(m, how){ if(done) return; done=true; out.how=how; fromCode(out, m); if(!out.brand && /SM-|Samsung/i.test(ua)) fromCode(out, ua); res(out); };
      var uad=navigator.userAgentData;
      if(uad && uad.getHighEntropyValues){
        uad.getHighEntropyValues(['model']).then(function(v){ fin(v && v.model, 'uach'); }, function(){ fin(ua, 'ua'); });
        setTimeout(function(){ fin(ua, 'ua'); }, 900);
      } else fin(ua, 'ua');
    });
  }

  /* The phone for a product kind: the visitor's own pick for that brand, else the detected device of that brand. */
  var dev=null;
  function phoneFor(kind){
    var p=get(KEY);
    if(p && p.brand===kind && p.model) return {model:p.model, conf:'picked', cands:[p.model]};
    if(dev && dev.brand===kind && dev.model) return {model:dev.model, conf:dev.conf, cands:dev.cands};
    return null;
  }
  /* The brand to align the store to: the detected phone if we sell its model, else the last pick. */
  function primary(){
    if(dev && dev.model) return {brand:dev.brand, model:dev.model, own:true, conf:dev.conf};
    var p=get(KEY);
    if(p && p.model) return {brand:p.brand, model:p.model, own:false, conf:'picked'};
    return null;
  }
  function remember(model, how){
    var kind=kindOf(model); if(!kind) return;
    var p=get(KEY);
    if(p && p.model===model) return;
    put(KEY, {brand:kind, model:model, t:Date.now()});
    emit('myntelo_device_pick', {brand:kind, model:model, how:how, matched_detection:!!(dev && dev.model===model)});
  }

  /* ---------- styles ---------- */
  function css(){
    if(D.getElementById('mdf-css')) return;
    var st=D.createElement('style'); st.id='mdf-css';
    st.textContent=[
      '.mdf{margin:0 0 14px;color:#101519}',
      '.mdf__q{display:block;margin:0 0 8px;font-family:"Geist Mono",ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;font-size:12px;letter-spacing:.08em;text-transform:uppercase}',
      '.mdf__q small{margin-left:8px;font-size:11px;letter-spacing:.04em;text-transform:none;opacity:.6}',
      '.mdf__chips{display:flex;flex-wrap:wrap;gap:6px}',
      '.mdf__chip{display:inline-flex;align-items:center;min-height:40px;padding:0 15px;border-radius:999px;border:1px solid rgba(16,21,25,.16);background:linear-gradient(180deg,#fff,#f4f5f8);color:#101519;font:500 13px/1 Geist,ui-sans-serif,system-ui,sans-serif;cursor:pointer;box-shadow:inset 0 1px 0 #fff,0 1px 2px rgba(28,24,64,.06);transition:background-color .18s ease,color .18s ease,border-color .18s ease}',
      '.mdf__chip:hover{border-color:rgba(16,21,25,.4)}',
      '.mdf__chip[aria-pressed="true"]{background:#101519;border-color:#101519;color:#f5f6f6;box-shadow:none}',
      '.mdf__chip--other{background:transparent;border-style:dashed;box-shadow:none;color:rgba(16,21,25,.75)}',
      '.mdf__chip:focus-visible,.mdf__link:focus-visible{outline:2px solid #101519;outline-offset:2px}',
      '.mdf__ok{display:inline-flex;align-items:center;flex-wrap:wrap;gap:4px 10px;padding:9px 14px 9px 10px;border-radius:999px;background:linear-gradient(180deg,rgba(238,244,255,.95),rgba(232,236,252,.95));box-shadow:inset 0 0 0 1px rgba(91,110,220,.22);font:400 13px/1.3 Geist,ui-sans-serif,system-ui,sans-serif}',
      '.mdf__ok b{font-weight:600}',
      '.mdf__tick{display:inline-grid;place-items:center;width:20px;height:20px;border-radius:50%;background:#101519;color:#fff;font-size:11px;line-height:1}',
      '.mdf__link{padding:0;border:0;background:none;color:inherit;font:inherit;text-decoration:underline;text-underline-offset:3px;opacity:.7;cursor:pointer}',
      '.mdf-nudge{display:flex;align-items:center;gap:12px;margin:0 0 14px;padding:12px 12px 12px 16px;border-radius:20px;text-decoration:none;color:#101519;background:linear-gradient(135deg,rgba(220,230,255,.85),rgba(238,228,255,.85));box-shadow:inset 0 0 0 1px rgba(110,110,210,.22),0 8px 22px rgba(28,24,64,.08);font:400 14px/1.35 Geist,ui-sans-serif,system-ui,sans-serif}',
      '.mdf-nudge b{font-weight:600}',
      '.mdf-nudge__go{flex:none;margin-left:auto;padding:10px 14px;border-radius:999px;background:#101519;color:#f5f6f6;font:500 12px/1 "Geist Mono",ui-monospace,SFMono-Regular,Menlo,monospace;letter-spacing:.08em;text-transform:uppercase;white-space:nowrap}',
      '.mdf-nudge:hover .mdf-nudge__go{background:#2a3036}',
      '.mdf-nudge:focus-visible{outline:2px solid #101519;outline-offset:3px}',
      '.m-device__opt.mdf-yours{position:relative}',
      '.m-device__opt.mdf-yours::after{content:"";position:absolute;top:8px;right:12px;width:7px;height:7px;border-radius:50%;background:#5b7cff;box-shadow:0 0 0 3px rgba(91,124,255,.22)}',
      '@media (prefers-reduced-motion:reduce){.mdf__chip{transition:none}}'
    ].join('\n');
    D.head.appendChild(st);
  }

  /* ---------- 2a. model dropdowns ---------- */
  function setSelect(sel, model){
    if(sel.value===model) return;
    sel.value=model;
    sel.dispatchEvent(new Event('change', {bubbles:true}));
    /* The 3D stage follows dropdown changes once it is live; before that it boots from data-model, so hand it the phone now. */
    var scope=sel.closest('.product, section') || D;
    scope.querySelectorAll('[data-m3d]').forEach(function(r){
      if(r._m3dSetModel) r._m3dSetModel(model);
      else if(!r.dataset.m3dReady && !r.dataset.glb) r.dataset.model=model;
    });
  }
  function bar(vs){
    var sel=vs.querySelector('select'); if(!sel) return;
    var opts=[].map.call(sel.options, function(o){ return o.value; });
    var kind=kindOf(opts[0]); if(!kind) return;
    var has=function(m){ return opts.indexOf(m)>=0; };
    var box=vs._mdfBox;
    if(!box){
      box=vs._mdfBox=D.createElement('div'); box.className='mdf'; box.setAttribute('aria-live','polite');
      vs.parentNode.insertBefore(box, vs);
      box.addEventListener('click', function(e){
        var b=e.target.closest('[data-mdf-model],[data-mdf-other]'); if(!b) return;
        if(b.hasAttribute('data-mdf-other')){ sel.focus(); try{ sel.showPicker && sel.showPicker(); }catch(x){} return; }
        var m=b.getAttribute('data-mdf-model');
        remember(m, 'chip'); setSelect(sel, m); bar(vs);
      });
    }
    var ph=phoneFor(kind), cur=sel.value, html='';
    if(ph && has(ph.model)){
      if(ph.conf==='guess' && cur!==ph.model && ph.cands.indexOf(cur)<0) ph=null;      // visitor already chose something outside the guess
    }
    if(!ph){ box.hidden=true; box.innerHTML=''; return; }
    var label=kind==='iphone' ? 'iPhone' : 'Galaxy';
    if(ph.conf==='guess'){
      var c=ph.cands.filter(has).slice(0,4);
      if(!c.length){ box.hidden=true; return; }
      html='<span class="mdf__q">Your '+label+'?<small>Matched to your screen size</small></span><div class="mdf__chips" role="group" aria-label="Pick your '+label+'">'+
        c.map(function(m){ return '<button type="button" class="mdf__chip" data-mdf-model="'+esc(m)+'" aria-pressed="'+(cur===m)+'">'+esc(short(m))+'</button>'; }).join('')+
        '<button type="button" class="mdf__chip mdf__chip--other" data-mdf-other>Other</button></div>';
    } else if(has(ph.model) && cur===ph.model){
      html='<span class="mdf__ok"><span class="mdf__tick" aria-hidden="true">✓</span><span>Fits your <b>'+esc(short(ph.model))+'</b></span><button type="button" class="mdf__link" data-mdf-other>Change</button></span>';
    } else if(has(ph.model)){
      html='<span class="mdf__ok"><span>Your phone is the <b>'+esc(short(ph.model))+'</b>?</span><button type="button" class="mdf__link" data-mdf-model="'+esc(ph.model)+'">Switch to it</button></span>';
    } else { box.hidden=true; box.innerHTML=''; return; }
    box.innerHTML=html; box.hidden=false;
  }
  function selects(){
    D.querySelectorAll('variant-selects').forEach(function(vs){
      var sel=vs.querySelector('select'); if(!sel || vs._mdfInit) return; vs._mdfInit=1;
      var opts=[].map.call(sel.options, function(o){ return o.value; }), kind=kindOf(opts[0]); if(!kind) return;
      var ph=phoneFor(kind);
      var locked=vs.dataset.updateUrl!=='false' && /[?&]variant=/.test(location.search);
      if(ph && opts.indexOf(ph.model)>=0 && !locked && sel.value!==ph.model){ vs._mdfApplied=1; setSelect(sel, ph.model); }
      bar(vs);
      sel.addEventListener('change', function(e){ if(e.isTrusted) remember(sel.value, 'dropdown'); bar(vs); });
    });
  }

  /* ---------- 2b. the other device's twin ---------- */
  function nudge(){
    var pr=primary(); if(!pr) return;
    D.querySelectorAll('.m-device').forEach(function(sw){
      if(sw._mdf) return; sw._mdf=1;
      var opts=[].slice.call(sw.querySelectorAll('.m-device__opt')), mine=null, active=null;
      opts.forEach(function(o){
        var g=/galaxy/i.test(o.textContent) ? 'galaxy' : 'iphone';
        if(g===pr.brand) mine=o;
        if(o.classList.contains('is-active')) active=g;
      });
      if(!mine) return;
      if(pr.own){ mine.classList.add('mdf-yours'); mine.setAttribute('title','Your phone'); }
      if(active===pr.brand || mine.tagName!=='A') return;
      var coll=sw.classList.contains('m-device--collection');
      var name=pr.conf==='guess' ? (pr.brand==='iphone' ? 'iPhone' : 'Galaxy') : esc(short(pr.model));
      var lead=pr.own ? 'On '+(pr.brand==='iphone' ? 'an' : 'a')+' <b>'+name+'</b>?' : 'Shopping for your <b>'+name+'</b>?';
      var a=D.createElement('a'); a.className='mdf-nudge'; a.href=mine.getAttribute('href');
      a.innerHTML='<span>'+lead+' '+(coll ? 'See the '+(pr.brand==='galaxy' ? 'Galaxy' : 'iPhone')+' collection.' : 'This design is made for '+(pr.brand==='galaxy' ? 'Galaxy' : 'iPhone')+' too.')+'</span><span class="mdf-nudge__go">'+(coll ? 'Show me' : 'Switch')+' ↗</span>';
      a.addEventListener('click', function(){ emit('myntelo_device_nudge', {brand:pr.brand, model:pr.model, from:coll ? 'collection' : 'product'}); });
      sw.parentNode.insertBefore(a, sw);
    });
  }

  /* ---------- 2c. Galaxy visitors: homepage grid + Shop links ---------- */
  function galaxyStore(){
    var pr=primary(); if(!pr || pr.brand!=='galaxy' || !pr.own) return;
    if(CFG.gx) D.querySelectorAll('.m-header .m-navdrop>a, .m-header .m-nav-shop').forEach(function(a){ a.href=CFG.gx; });
    if(!D.body.classList.contains('template-index')) return;
    var cards=[].slice.call(D.querySelectorAll('a.m-card[href*="-magsafe-tough-phone-case"]'));
    if(!cards.length || !CFG.gx) return;
    fetch(CFG.gx.replace(/\/$/,'')+'/products.json?limit=250', {credentials:'same-origin'}).then(function(r){ return r.ok ? r.json() : null; }).then(function(j){
      if(!j || !j.products) return;
      var by={};
      j.products.forEach(function(p){ if(/-galaxy-tough-case$/.test(p.handle)) by[p.handle.replace(/-galaxy-tough-case$/,'')]=p; });
      cards.forEach(function(c){
        var m=(c.getAttribute('href')||'').match(/\/products\/([^/?#]+)-magsafe-tough-phone-case/), p=m && by[m[1]];
        if(!p || !p.variants || !p.variants.some(function(v){ return v.available; })) return;
        c.href='/products/'+p.handle;
        var h=c.querySelector('h3'); if(h) h.textContent=p.title;
        var pe=c.querySelector('.m-card__price'), v0=p.variants[0];
        if(pe && v0){
          var cc=(W.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', f=function(x){ try{ return new Intl.NumberFormat(D.documentElement.lang||'en', {style:'currency', currency:cc}).format(+x); }catch(e){ return '$'+x; } };
          pe.innerHTML=esc(f(v0.price))+(v0.compare_at_price && +v0.compare_at_price>+v0.price ? ' <s>'+esc(f(v0.compare_at_price))+'</s>' : '');
        }
        var im=c.querySelector('img'), src=p.images && p.images[0] && p.images[0].src;
        if(im && src){ var u=src+(src.indexOf('?')>=0 ? '&' : '?')+'width=750'; im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src=u; im.alt=p.title; }
        c.setAttribute('data-mdf-galaxy','');
      });
      /* Designs without a Galaxy version yet move behind the ones this visitor can buy; the grid keeps its size and numbering. */
      var grid=cards[0].parentNode, all=[].slice.call(grid.querySelectorAll('a.m-card')), shown=all.filter(function(c){ return !c.hidden; }).length;
      var fit=all.filter(function(c){ return c.hasAttribute('data-mdf-galaxy'); }), rest=all.filter(function(c){ return !c.hasAttribute('data-mdf-galaxy'); });
      if(fit.length && rest.length) fit.concat(rest).forEach(function(c, n){
        c.hidden=n>=shown; grid.appendChild(c);
        var i=c.querySelector('.m-card__index'); if(i) i.textContent=(n<9 ? '0' : '')+(n+1);
      });
    }).catch(function(){});
  }

  /* ---------- run ---------- */
  function run(){
    css();
    var go=function(){ selects(); nudge(); galaxyStore(); };
    if(W.customElements && customElements.whenDefined) Promise.race([customElements.whenDefined('variant-selects'), new Promise(function(r){ setTimeout(r, 1500); })]).then(go);
    else go();
  }
  detect().then(function(d){
    dev=d;
    var key='mdf:sent';
    try{ if(!sessionStorage.getItem(key)){ sessionStorage.setItem(key,'1'); emit('myntelo_device', {brand:d.brand||'none', model:d.model||'', confidence:d.conf, how:d.how||'', os:d.os, size_class:d.cls||'', code:d.code||''}); } }catch(e){}
    W.MynteloDevice={device:d, phoneFor:phoneFor, primary:primary, forget:function(){ try{ localStorage.removeItem(KEY); sessionStorage.removeItem(SKEY); }catch(e){} }};
    /* Run after DOMContentLoaded (a deferred script runs just before it), one tick late, so the theme's own DOMContentLoaded
       handlers (Add to bag price label, product form) are listening before the dropdown changes. */
    var nav=W.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if(D.readyState==='complete' || (nav && nav.domContentLoadedEventEnd>0)) setTimeout(run, 0);
    else D.addEventListener('DOMContentLoaded', function(){ setTimeout(run, 0); });
  });
  D.addEventListener('shopify:section:load', function(){ selects(); nudge(); });
})();
